import { validateProps } from '../utils';
export const isValidProviderStatus = providerStatus => validateProps(providerStatus, ['provider', 'optInStatus']);
//# sourceMappingURL=ProviderStatus.js.map